module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3.876-1.008a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 4 9H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 12 7h3a1 1 0 0 1 0 2h-3a1.01 1.01 0 0 1-.124-.008z\"/></svg>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_commit.svg
// module id = ../../views/shared/icons/_icon_commit.svg
// module chunks = commit_pipelines environments environments_folder pipelines